import { tss } from 'tss-react/mui';

import type { ThemeMode } from '@/types/theme.ts';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
    themeMode: ThemeMode;
  }>()
  .create(({ theme, isLayoutMobile, themeMode }) => ({
    assetDetailsSubTopbar: {
      backgroundColor: theme.vars.palette.background.elevation1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      zIndex: 2,
      position: 'sticky'
    },
    assetDetailsSubTopbarBottom: {
      ...(isLayoutMobile && {
        position: 'relative',
        width: '100vw'
      })
    },
    bottomContent: {
      background: `repeating-linear-gradient(to bottom, ${
        themeMode === 'dark' ? '#333c4d' : '#eceff1'
      } 0 3.5rem, ${theme.vars.palette.border.light} 0 3.55rem)`,
      backgroundColor: themeMode === 'dark' ? '#333c4d' : '#eceff1',
      borderBottom: `0.0625rem solid ${theme.vars.palette.border.light}`,
      borderTop: `0.0625rem solid ${theme.vars.palette.border.light}`,
      boxShadow: isLayoutMobile ? 'none' : theme.shadows[2],
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative',
      width: '100%',
      [theme.breakpoints.down('xl')]: {
        display: 'block',
        '& > *': {
          background: theme.spacing(5)
        }
      }
    },
    bottomContentGrid: {
      alignItems: 'center',
      display: 'flex',
      padding: theme.spacing(0, 0, 0, 2),
      '& > *': {
        minWidth: '7rem',
        paddingLeft: theme.spacing(1)
      },
      [theme.breakpoints.down('xl')]: {
        alignItems: 'center',
        background: `repeating-linear-gradient(to bottom, ${
          themeMode === 'dark' ? '#333c4d' : '#eceff1'
        } 0 3.5rem, ${theme.vars.palette.border.light} 0 3.55rem)`,
        display: 'grid',
        gridAutoRows: '3.5rem',
        gridRowGap: '0.0625rem',
        gridTemplateColumns: 'repeat(auto-fill, minmax(13rem, max-content))'
      }
    },
    bottomContentBackButton: {
      alignItems: 'center',
      backgroundColor:
        themeMode === 'dark' ? '#49505e!important' : '#d5d7d8!important',
      borderRadius: 0,
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      minWidth: theme.spacing(3),
      padding: 0,
      position: 'absolute',
      top: 0,
      '&:hover': {
        backgroundColor:
          themeMode === 'dark' ? '#333c4d!important' : '#eceff1!important'
      },
      [theme.breakpoints.down('xl')]: {
        borderBottom: `0.0625rem solid ${theme.vars.palette.border.light}`
      }
    },
    bottomContentSection: {
      display: 'flex',
      height: '3.5rem',
      borderLeft: `0.0625rem solid ${theme.vars.palette.border.light}`,
      [theme.breakpoints.down('xl')]: {
        display: 'block',
        height: 'inherit'
      },
      ...(!isLayoutMobile && {
        marginLeft: `${theme.spacing(3)}`
      })
    },
    bottomContentSectionKeys: {
      color: theme.vars.palette.text.secondary,
      display: 'block'
    },
    bottomContentSectionValues: {
      fontWeight: 700
    }
  }));

export default useStyles;
